/* eslint-disable react/jsx-filename-extension, max-len */
import React from 'react';
import './index.css';

const CATEGORY_CONTENT = [
  {
    match: /medical-seating/i,
    title: 'Medical Seating',
    description: 'Medical seating for examination rooms, treatment areas, laboratories, and healthcare workstations, with durable, easy-to-clean designs for demanding clinical environments.',
    links: [['/office-seating', 'Office Seating'], ['/controlled-environment-seating', 'Controlled Environment Seating']],
  },
  {
    match: /office-seating|\/office(?:$|\/)/i,
    title: 'Office Seating',
    description: 'Office seating for desks, shared work areas, training rooms, and everyday administrative spaces, with options for ergonomic support, mobility, and long working sessions.',
    links: [['/laboratory-seating', 'Laboratory Seating'], ['/medical-seating', 'Medical Seating']],
  },
  {
    match: /laboratory-seating/i,
    title: 'Laboratory Seating',
    description: 'Laboratory seating for benches, workstations, and technical environments, with durable and adjustable designs for focused work.',
    links: [['/office-seating', 'Office Seating'], ['/controlled-environment-seating', 'Controlled Environment Seating']],
  },
  {
    match: /\/medical-seating\/(?:chairs|stools|stools-with-backs|speciality)/i,
    title: 'Medical Seating',
    description: 'Medical seating for examination rooms, treatment areas, laboratories, and healthcare workstations, with durable, easy-to-clean designs for demanding clinical environments.',
    links: [['/medical-seating', 'Medical Seating']],
  },
  {
    match: /\/office-seating\/(?:chairs|stools|stools-with-backs|speciality)/i,
    title: 'Office Seating',
    description: 'Office seating for desks, shared work areas, training rooms, and everyday administrative spaces, with options for ergonomic support, mobility, and long working sessions.',
    links: [['/office-seating', 'Office Seating']],
  },
  {
    match: /\/cleanroom-chairs$/i,
    title: 'Cleanroom Chairs',
    description: 'Cleanroom chairs for controlled manufacturing, laboratory, and pharmaceutical environments. Choose seating with cleanable surfaces, low-particle materials, and ergonomic support for extended work.',
    links: [['/controlled-environment-seating/cleanroom-stools', 'Cleanroom Stools'], ['/controlled-environment-seating/esd-cleanroom-chairs', 'ESD Cleanroom Chairs']],
  },
  {
    match: /\/cleanroom-stools$/i,
    title: 'Cleanroom Stools',
    description: 'Cleanroom stools for benches, workstations, and controlled environments. Compare cleanable, durable designs for technicians and operators who need compact, height-adjustable seating.',
    links: [['/controlled-environment-seating/cleanroom-chairs', 'Cleanroom Chairs'], ['/controlled-environment-seating/esd-cleanroom-chairs', 'ESD Cleanroom Chairs']],
  },
  {
    match: /\/esd-cleanroom-chairs$/i,
    title: 'ESD & Cleanroom Chairs',
    description: 'ESD cleanroom chairs combine static-dissipative protection with cleanroom-compatible construction for electronics assembly, semiconductor, pharmaceutical, and other sensitive work areas.',
    links: [['/controlled-environment-seating/esd-chairs', 'ESD Chairs'], ['/controlled-environment-seating/cleanroom-chairs', 'Cleanroom Chairs']],
  },
  {
    match: /esd-chairs/i,
    title: 'ESD Chairs',
    description: 'ESD chairs help control static electricity at electronics, laboratory, and technical workstations. Browse grounded and static-dissipative seating with ergonomic adjustment for precise work.',
    links: [['/controlled-environment-seating/esd-stools', 'ESD Stools'], ['/controlled-environment-seating/esd-cleanroom-chairs', 'ESD Cleanroom Chairs']],
  },
  {
    match: /esd-stools/i,
    title: 'ESD Stools',
    description: 'ESD stools provide static-dissipative seating for electronics assembly, inspection, repair, and other technical workstations where workers need mobility and a compact footprint.',
    links: [['/controlled-environment-seating/esd-chairs', 'ESD Chairs'], ['/controlled-environment-seating/esd-cleanroom-chairs', 'ESD Cleanroom Chairs']],
  },
  {
    match: /controlled-environment-seating|safety-controlled/i,
    title: 'Controlled Environment Seating',
    description: 'Controlled-environment seating includes ESD and cleanroom chairs and stools for electronics assembly, pharmaceutical production, laboratory work, and other areas with static-control or contamination requirements.',
    links: [
      ['/controlled-environment-seating/cleanroom-chairs', 'Cleanroom Chairs'],
      ['/controlled-environment-seating/cleanroom-stools', 'Cleanroom Stools'],
      ['/controlled-environment-seating/esd-chairs', 'ESD Chairs'],
      ['/controlled-environment-seating/esd-stools', 'ESD Stools'],
    ],
  },
  {
    match: /industrial-seating/i,
    title: 'Industrial Seating',
    description: 'Industrial seating for manufacturing lines, workbenches, inspection stations, warehouses, and technical shops. Compare durable chairs and stools by height, mobility, materials, and support.',
    links: [['/industrial-seating/stools-with-backs', 'Industrial Stools with Backs']],
  },
  {
    match: /stools-with-backs/i,
    title: 'Stools with Backs',
    description: 'Stools with backs provide the working height and compact footprint of a stool with added lumbar and upper-body support. Find durable seating for benches, counters, labs, and industrial workstations.',
    links: [['/industrial-seating', 'Industrial Seating']],
  },
];

const getContent = () => CATEGORY_CONTENT.find(({ match }) => match.test(window.location.pathname)) || {
  title: 'Laboratory and Technical Seating',
  description: 'Explore chairs and stools for laboratory, office, education, and technical workspaces. Compare seating by height, material, base, and other configuration options.',
  links: [
    ['/controlled-environment-seating', 'Controlled Environment Seating'],
    ['/industrial-seating/stools-with-backs', 'Industrial Stools with Backs'],
  ],
};

export default function Loading() {
  return (
    <main className="initial-content" aria-busy="true">
      <h1>{getContent().title}</h1>
      <p>{getContent().description}</p>
      <nav aria-label="Seating categories">
        {getContent().links.map(([href, label]) => <a key={href} href={href}>{label}</a>)}
      </nav>
    </main>
  );
}
